"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transform = void 0;
var Transform = /** @class */ (function () {
    function Transform(scale, translate, angle) {
        this.scale = scale;
        this.translate = translate;
        this.angle = angle;
    }
    Transform.none = function () {
        return new Transform({ x: 1, y: 1 }, { x: 0, y: 0 }, 0);
    };
    return Transform;
}());
exports.Transform = Transform;
//# sourceMappingURL=Transform.js.map